<template>
	<div class="hello subcontainer">
		<div class="status">
			<img v-if="mappedStatus == 'pickup'" src="../../static/pickup.png" alt="Pickup" />
			<img v-else-if="mappedStatus == 'intransit'" src="../../static/intransit.png" alt="In Transit" />
			<img v-else-if="mappedStatus == 'onboard'" src="../../static/onboard.png" alt="On Board" />
			<img v-else-if="mappedStatus == 'delivered'" src="../../static/delivered.png" alt="Delivered" />
			<img v-else-if="mappedStatus == 'none'" src="../../static/nostatus.png" alt="Delivered" />
			<img v-else src="../../static/nostatus.png" alt="Delivered" />
		</div>
	</div>

</template>

<script>
	import StatusMapper from '../domain/StatusMapper'
	export default {
		loader: true,
		props: {
			trackingstatus: String
		},
		computed: {
			mappedStatus() {
				return StatusMapper(this.trackingstatus)
			}
		},
		methods: {
			add() {
				this.count++;
			}
		}		
	}
</script>

<style scoped>
    .subcontainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
    }
    .status > img {
        width: 100%;
    }
</style>